import axios from 'axios';
console.log(process.env.REACT_APP_BASE_URL);
const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL
});

api.interceptors.response.use(
    response => response,
    error => {

        // Se tiver response (erro HTTP)
        if (error.response) {

            if (error.response.status === 401) {
                localStorage.removeItem("@authApp: id");
                localStorage.removeItem("@authApp: token");
                localStorage.removeItem("@authApp: user");
                localStorage.removeItem("@authApp: userType");
                window.location = "/login";
            }

            // Aqui retorna o erro normalmente para o componente
            return Promise.reject(error);
        }

        // Erros sem response (timeout, network)
        return Promise.reject({
            message: "Erro de conexão",
            originalError: error
        });
    }
);


api.interceptors.request.use(async function (config) {
    config.headers.system = "control";
    let tokenAs;
    let username;
    if (localStorage.getItem("@authApp: token")) {
        tokenAs = localStorage.getItem("@authApp: token").replace(/^"|"$/g, '');
        const user_local = localStorage.getItem("@authApp: user").replace(/^"|"$/g, '');
        const user_local_trade = user_local.replace(/\\/g, '');
        const user_obj = JSON.parse(user_local_trade);
        username = user_obj.username;
    }
    const token = await (`Bearer ${tokenAs}`);
    if (token !== null) {
        if (config.method !== 'OPTIONS') {
            config.headers.authorization = token;
        }
        if (username) {
            config.headers.common['username'] = username;
        }
    }
    //config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    //config.headers['Pragma'] = 'no-cache';
    //config.headers['Expires'] = '0';
    return config;
}, function (error) {
    if (error.response.status === 401) {
        localStorage.removeItem("@authApp: id"); // <-- add your var
        localStorage.removeItem("@authApp: token")
        localStorage.removeItem("@authApp: user")
        localStorage.removeItem("@authApp: userType")
        window.location = "/login";  // <-- add your path
    }
    console.log('ERROR API INTERCEPTOS REQUEST ', error)
    //Alert.alert('Problema na requisição', error.message);
})

export default api;

// para chamar const response = await api.post('/dala',{ passar variáveis});